import Vue from "vue";
import VueI18n from "vue-i18n";
import NaicsLookup from "./components/NaicsLookup.vue";
import vueCustomElement from "vue-custom-element";
//import vSelect from "vue-select";
// import for footer and error notification
import { Collapse, Icon, Dialog, Notification } from "buefy";
Vue.use(Collapse);
Vue.use(Icon);
Vue.use(Dialog);
Vue.use(Notification);
Vue.use(vueCustomElement);
/*  Temporary disabled , since we don't use Font yet
    it greatly reduced size of the build libarary
Vue.use(Buefy, {
  defaultIconPack: "fa" // fa FontAwsome
});
*/
//Vue.component("v-select", vSelect);

Vue.use(VueI18n);

// Create VueI18n instance with options
export const i18n = new VueI18n({
  locale: "en"
});

Vue.config.productionTip = false;
Vue.customElement("open-services-naics-lookup", NaicsLookup);
